import React, { useEffect, useMemo, useState } from "react";
import { api, asAbsolute } from "@/lib/api";
import { FileText, Download, ShieldCheck } from "lucide-react";

export default function Transparency() {
    const [docs, setDocs] = useState([]);
    useEffect(() => { api.get("/documents").then((r) => setDocs(r.data || [])); }, []);
    const grouped = useMemo(() => {
        const g = {};
        for (const d of docs) (g[d.category] ||= []).push(d);
        return g;
    }, [docs]);

    return (
        <div data-testid="transparency-page">
            <section className="pt-20 pb-12 md:pt-32 md:pb-16">
                <div className="container-hero grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-7">
                        <div className="label-eyebrow text-brand-forest mb-4">Transparency & Compliance</div>
                        <h1 className="font-display text-5xl sm:text-6xl font-semibold leading-[1.05]">Everything you'd like to verify — in one place.</h1>
                    </div>
                    <div className="md:col-span-5 bg-brand-forest text-white rounded-2xl p-8">
                        <ShieldCheck size={28} className="mb-3" strokeWidth={1.5} />
                        <p className="text-white/85 leading-relaxed">All Kabir Foundation registrations, audited financials and governance policies are published here. Please email <a href="mailto:support@kabirfoundation.org" className="underline">support@kabirfoundation.org</a> for the latest signed copies.</p>
                    </div>
                </div>
            </section>
            <section className="pb-24 md:pb-32">
                <div className="container-hero space-y-12">
                    {Object.entries(grouped).map(([cat, items]) => (
                        <div key={cat}>
                            <div className="label-eyebrow text-brand-forest mb-4">{cat}</div>
                            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                {items.map((d) => (
                                    <a
                                        key={d.id}
                                        href={asAbsolute(d.url) || "#"}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`document-${d.id}`}
                                        className="group bg-white rounded-2xl p-7 border border-black/5 hover:border-brand-forest/40 hover:shadow-md transition-colors duration-200 flex items-start gap-4"
                                    >
                                        <div className="w-11 h-11 rounded-xl bg-brand-forest/10 text-brand-forest grid place-items-center flex-shrink-0">
                                            <FileText size={20} strokeWidth={1.5} />
                                        </div>
                                        <div className="flex-1">
                                            <div className="font-display text-lg font-medium leading-snug">{d.label}</div>
                                            {d.description && <p className="text-slate-500 text-sm mt-1">{d.description}</p>}
                                            <div className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-brand-forest">View <Download size={14} /></div>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
